import { FormattedMessage, useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import React from 'react'
import { AsyncView } from '@aboutbits/react-toolbox'
import { HeaderArea, HeaderTitle } from '../../../shared/header'
import { HeaderBackAction } from '../../../shared/header/HeaderBackAction'
import { translationsShared } from '../../../shared/translations/translationsShared'
import { IconClose } from '../../../shared/svgs'
import { translationsProfile } from '../translations/translations'
import { useGetUserSettings } from '../db/userProfile'
import { ProfileEditSection } from './ProfileEditSection'

export default function ProfileEdit() {
  const intl = useIntl()
  const navigate = useNavigate()
  const userProfileQuery = useGetUserSettings()

  return (
    <>
      <HeaderArea
        navigation={
          <HeaderBackAction
            label={intl.formatMessage(translationsShared.goBack)}
            onClick={() => navigate(-1)}
            icon={IconClose}
          />
        }
      >
        <HeaderTitle>
          <FormattedMessage {...translationsProfile.editProfileTitle} />
        </HeaderTitle>
      </HeaderArea>
      <AsyncView
        {...userProfileQuery}
        renderSuccess={(data) =>
          data ? <ProfileEditSection data={data} /> : null
        }
      />
    </>
  )
}
